import {
  CustomerNoNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { gql } from "@apollo/client";

export const QUERY_CUSTOMER_LIST = gql`
  ${PaginatedListMetaNoNestingFragment}
  ${CustomerNoNestingFragment}
  query customers($options: CustomerListOptions) {
    customers(options: $options) {
      items {
        ...CustomerNoNesting
      }
      meta {
        ...PaginatedListMetaNoNesting
      }
    }
  }
`;
